
const init={data:[]}
const reducer = (state =init, action) => {
  return state
};

export { reducer };
